import type { ReactNode } from 'react';
import { History } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@ui/card.tsx';

type HistoryCardProps = {
  title: string;
  description: string;
  children: ReactNode;
};

export function HistoryCard({ title, description, children }: HistoryCardProps) {
  if (!children) return null;

  return (
    <Card className="w-full">
      <CardHeader className="p-10 pb-2">
        <CardTitle className="flex items-center space-x-2 text-xl font-author-complete font-regular">
          <History />
          <p className="text-xl font-bold">{title}</p>
        </CardTitle>
      </CardHeader>

      <CardContent className="flex flex-col p-10 pt-0 space-y-4">
        <p className="text-muted-foreground">{description}</p>
        {children}
      </CardContent>
    </Card>
  );
}
